import { useMemo } from 'react';
import * as React from 'react';

import { BetType } from '@/lib/apollo/types/gen/graphql';
import { getOddsRange } from '@/lib/race';
import { Odds } from '@/modelTypes';

import { Span } from './style';

interface RefundRangeProps {
  setNums: number[];
  betType: BetType;
  count: number;
  odds: Odds | null;
}

const RefundRange: React.FC<RefundRangeProps> = ({
  setNums,
  betType,
  count,
  odds,
}) => {
  const oddsRange = useMemo(() => {
    if (odds) {
      return getOddsRange(odds, setNums, betType);
    }
    return null;
  }, [odds, setNums, betType]);

  if (!oddsRange) {
    return <>-</>;
  }

  if (betType === BetType.QuinellaPlace || setNums.length > 1) {
    return (
      <span>
        {Math.round(oddsRange.min * count * 100).toLocaleString()}
        <Span>~</Span>
        {`${Math.round(oddsRange.max * count * 100).toLocaleString()}円`}
      </span>
    );
  }

  return (
    <span>{`${Math.round(
      oddsRange.max * count * 100,
    ).toLocaleString()}円`}</span>
  );
};

export default RefundRange;
